<template>
  <div class="card-container">
    <card class="card-login card-white">
      <Header pageTitle="Welcome to AGATRS!"></Header>
      <hr />
      <!-- {{$route.params.id}} -->
      {{ htmlstr }}
    </card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "@/components/App/Header";
export default {
  name: "GenerateACSAPage",
  components: {
    Header,
  },
  data: function () {
    return {
      htmlstr: "",
    };
  },
  computed: {},
  mounted: function () {
    this.generateAcsa();
  },
  updated: function () {},
  destroyed: function () {},
  methods: {
    generateAcsa() {
      // This is not implemented yet.  The following code is a placeholder.
      var fs = require("fs");

      var reader = new FileReader();
      // reader.readAsArrayBuffer(e.target.files[0]);

      reader.readAsArrayBuffer("@/Configureable ACSA Form.xlsx");
      var data = new Uint8Array(reader.result);
      this.htmlstr = XLSX.write(wb, {
        sheet: "sheet no1",
        type: "binary",
        bookType: "html",
      });
    },
  },
};
</script>

<style></style>
